import { fetchMessageDesignsApi } from '../api/MessageDesignsApi';

import {
    ADD_DISCOUNT,
    DISABLE_SUBMITED,
    FETCH_MESSAGE_DESIGNS,
    SET_MESSAGE_PICKER
} from './actionTypes';

export function disableSubmitedState() {
    return {
        type: DISABLE_SUBMITED,
        payload: null
    };
}

export function addDiscount(discountObj) {
    return {
        type: ADD_DISCOUNT,
        payload: discountObj
    };
}

export function fetchMessageDesigns(country) {
    const request = fetchMessageDesignsApi(country);
    return {
        type: FETCH_MESSAGE_DESIGNS,
        payload: request
    };
}

export function setMessagePicker(pickerData) {
    return {
        type: SET_MESSAGE_PICKER,
        payload: pickerData
    };
}
